/* eslint-disable */
import GraphQL from '../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IssuesScreenDesktopHeaderQueryVariables = GraphQL.Exact<{
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IssuesScreenDesktopHeaderQuery = { readonly __typename?: 'Query', readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly health: number | null } | null };


export const IssuesScreenDesktopHeaderDocument = gql`
    query IssuesScreenDesktopHeader($websiteId: WebsiteId!) {
  website(id: $websiteId) {
    id
    health
  }
}
    `;

/**
 * __useIssuesScreenDesktopHeaderQuery__
 *
 * To run a query within a React component, call `useIssuesScreenDesktopHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useIssuesScreenDesktopHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIssuesScreenDesktopHeaderQuery({
 *   variables: {
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIssuesScreenDesktopHeaderQuery(baseOptions: Apollo.QueryHookOptions<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables> & ({ variables: IssuesScreenDesktopHeaderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>(IssuesScreenDesktopHeaderDocument, options);
      }
export function useIssuesScreenDesktopHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>(IssuesScreenDesktopHeaderDocument, options);
        }
export function useIssuesScreenDesktopHeaderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>(IssuesScreenDesktopHeaderDocument, options);
        }
export type IssuesScreenDesktopHeaderQueryHookResult = ReturnType<typeof useIssuesScreenDesktopHeaderQuery>;
export type IssuesScreenDesktopHeaderLazyQueryHookResult = ReturnType<typeof useIssuesScreenDesktopHeaderLazyQuery>;
export type IssuesScreenDesktopHeaderSuspenseQueryHookResult = ReturnType<typeof useIssuesScreenDesktopHeaderSuspenseQuery>;
export type IssuesScreenDesktopHeaderQueryResult = Apollo.QueryResult<IssuesScreenDesktopHeaderQuery, IssuesScreenDesktopHeaderQueryVariables>;